<template
    ><div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Client name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.name ? activeClient.name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ getClientCountry()
                }}<country-flag
                    v-if="activeClient && activeClient.country_code"
                    :country="activeClient.country_code"
                    class="ml-1"
                    size="small"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Region" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeClient.region
                        ? t(activeClient.region.charAt(0).toUpperCase() + activeClient.region.slice(1))
                        : "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.address ? activeClient.address : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Coordinates (lat/lon)" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.latitude ? activeClient.latitude : "-" }};{{
                    activeClient.longitude ? activeClient.longitude : "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Manager" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.manager_name ? activeClient.manager_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Total profit" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.total_profit ? activeClient.total_profit : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Met place" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.met_place_name ? activeClient.met_place_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Met date" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.met_date ? activeClient.met_date : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeClient.comment ? activeClient.comment : "-" }}
            </v-col>
        </v-row>
    </div></template
>

<script>
import { mapState } from "vuex";
import CountryFlag from "vue-country-flag";

export default {
    name: "client-info-tab",
    components: {
        CountryFlag
    },
    computed: {
        ...mapState("ExportClientStore", ["activeClient"])
    },
    methods: {
        getClientCountry() {
            if (this.activeClient.country_estonian) {
                return this.activeClient.country_estonian;
            }
            if (this.activeClient.country_english) {
                return this.activeClient.country_english;
            }
            return "-";
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
